import { singleton } from "logic/singleton";
export const TELEMETRY_DEBUG_STORAGE_KEY = "gl.telemetry-debug";
export const MAX_ENTRIES = 500;
const createTelemetryDebugStore = () => {
  let enabled = false;
  let entries = [];
  let nextId = 1;
  const listeners = /* @__PURE__ */ new Set();
  try {
    enabled = localStorage.getItem(TELEMETRY_DEBUG_STORAGE_KEY) === "true";
  } catch {
  }
  const notify = () => listeners.forEach((listener) => listener());
  return {
    isTelemetryDebugEnabled: () => enabled,
    setTelemetryDebugEnabled: (newEnabled) => {
      enabled = newEnabled;
      try {
        localStorage.setItem(TELEMETRY_DEBUG_STORAGE_KEY, String(newEnabled));
      } catch {
      }
      notify();
    },
    telemetryDebugStore: {
      record: (eventType, payload, status) => {
        if (!enabled) return;
        entries = [...entries, { id: nextId, timestamp: Date.now(), eventType, payload, status }].slice(-MAX_ENTRIES);
        nextId += 1;
        notify();
      },
      getEntries: () => entries,
      clear: () => {
        entries = [];
        notify();
      },
      subscribe: (listener) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
      }
    }
  };
};
export const { isTelemetryDebugEnabled, setTelemetryDebugEnabled, telemetryDebugStore } = singleton(
  "core.TelemetryDebugStore",
  createTelemetryDebugStore
);
